// startup
// Load entry module
__webpack_require__("./src/index.ts");
// This entry module used 'exports' so it can't be inlined
